module.exports = __webpack_public_path__ + "static/media/flag-haw.edaf38db.webp";